import {
  useContext,
  useEffect,
} from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import {
  HeaderLeftBlockContext,
} from './HeaderLeftBlockContext';

export type HeaderLeftBlockProps = {
  /**
   * Контент, который будет отображён в шапке страницы
   */
  children: ReactNode;
};

export function HeaderLeftBlock({
  children,
}: HeaderLeftBlockProps): ReactElement | null {
  const contextValue = useContext(HeaderLeftBlockContext);

  if (!contextValue) {
    throw new Error('[@n3/kit] `HeaderLeftBlock` should be used inside `Layout`');
  }

  const {
    setBlock,
  } = contextValue;

  useEffect(() => {
    const unsetBlock = setBlock(children);

    return () => {
      unsetBlock();
    };
  }, [
    children,
    setBlock,
  ]);

  return null;
}
